import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import cx from 'classnames'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'

import config from '../../../../../../config'

import HistoryButton from './components/HistoryButton'
import Collapse from '../../../../../../components/Collapse'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class BlockTable extends Component {
    static propTypes = {
        columns: PropTypes.number,
        data: PropTypes.array,
        historyButtonColumn: PropTypes.number,
        historyButtons: IPropTypes.map.isRequired,
        level: PropTypes.string,
        tableId: PropTypes.string.isRequired,
        toggleHistoryButton: PropTypes.func.isRequired,
        weights: PropTypes.array,
    }

    static defaultProps = {
        columns: 3,
        data: [],
        historyButtonColumn: 1,
        weights: [27, 46, 27],
    }

    onHistoryButtonClick = (buttonId) => {
        const { tableId, toggleHistoryButton } = this.props

        toggleHistoryButton(tableId, buttonId)
    }

    renderRows = (rows, className) => {
        const { weights } = this.props
        if (!rows) return null

        return _.map(rows, (row, rIndex) => {
            const columns = _.map(row, (column, cIndex) => {
                const weightClass = `weight_${weights[cIndex]}`

                let text = column.text
                if (column.translate) {
                    const textId = `scenes.Gnosus.components.Workspace.components.BlockTable.${column.text}`
                    text = <FormattedMessage id={textId} values={column.values} />
                }

                return (
                    <div key={`column_${rIndex}_${cIndex}`} className={cx('column', weightClass)}>
                        {text}
                    </div>
                )
            })

            return (
                <div key={`row_${rIndex}`} className={cx('row', className)}>
                    {columns}
                </div>
            )
        })
    }

    renderActiveRows = (rows) => {
        if (!rows) return null

        return this.renderRows(rows, 'active')
    }

    renderHistoryButtonRow = (buttonId, isOpen) => {
        const { columns, historyButtonColumn, weights } = this.props

        const historyButton = <HistoryButton id={buttonId} onClickHandler={this.onHistoryButtonClick} open={isOpen} />

        const historyColumns = _.map(Array(columns), (c, cIndex) => {
            const weightClass = `weight_${weights[cIndex]}`

            return (
                <div key={`column_history_${cIndex}`} className={cx('column', weightClass)}>
                    {cIndex === historyButtonColumn ? historyButton : null}
                </div>
            )
        })

        return (
            <div key={'row_history'} className={'row history-button'}>
                {historyColumns}
            </div>
        )
    }

    renderHistoryRows = (rows, level) => {
        const { historyButtons, tableId } = this.props
        if (!rows) return null

        const historyButtonId = `history_${level}`
        const isOpen = historyButtons.getIn([historyButtonId, 'open'], config.components.blockTable.historyOpen)

        const historyRows = this.renderRows(rows, 'history')
        const historyRowsWrap = config.components.blockTable.animated ? (
            <Collapse key={`history_rows_${level}`} noAnimateId={tableId} expand={isOpen} duration={1000}>
                <div className={'block-table-history-content'}>{historyRows}</div>
            </Collapse>
        ) : (
            <div key={`history_rows_${level}`} className={cx('block-table-history-content', !isOpen && 'hide')}>
                {historyRows}
            </div>
        )

        return [this.renderHistoryButtonRow(historyButtonId, isOpen), historyRowsWrap]
    }

    renderTable = () => {
        const { data, level } = this.props

        return _.map(data, (levelData) => {
            const tableBlockLevel = _.get(levelData, 'level')
            if (tableBlockLevel > level) return null

            const activeRows = this.renderActiveRows(_.get(levelData, 'active', null))
            const historyRows = this.renderHistoryRows(_.get(levelData, 'history', null), tableBlockLevel)

            return (
                <div key={`level_${tableBlockLevel}`} className={'block-table-body'}>
                    {activeRows}
                    {historyRows}
                </div>
            )
        })
    }

    render() {
        const { data } = this.props

        if (!data) return null

        return <div className={cx('block-table')}>{this.renderTable()}</div>
    }
}
